import { lazy } from "react";
import { useSelector } from "react-redux";
import { Route } from "react-router-dom";

const ProtectedPermissionRoute = ({ moduleKey, permissionId, ...reset }) => {
  const userPermissions = useSelector(({ auth }) => auth.permissions);

  return moduleKey !== undefined &&
    userPermissions[moduleKey] !== undefined &&
    userPermissions[moduleKey].includes(permissionId) ? (
    <Route {...reset} />
  ) : (
    <Route
      {...reset}
      component={lazy(() =>
        import(`../../../views/app-views/no-access-page/no-access-page`)
      )}
    />
  );
};

export default ProtectedPermissionRoute;

export const ProtectedPermissionComponent = ({
  moduleKey,
  permissionId,
  children,
}) => {
  const userPermissions = useSelector(({ auth }) => auth.permissions);
  return moduleKey !== undefined &&
    userPermissions[moduleKey] !== undefined &&
    userPermissions[moduleKey].includes(permissionId) ? (
    <>{children}</>
  ) : (
    <></>
  );
};

export const useMenuItemIsPermitted = () => {
  const userPermissions = useSelector(({ auth }) => auth.permissions);
  const isMenuItemPermitted = ({ moduleKey, permissionId }) => {
    return moduleKey !== undefined &&
      userPermissions[moduleKey] !== undefined &&
      userPermissions[moduleKey].includes(permissionId)
      ? true
      : false;
  };
  return [isMenuItemPermitted];
};
